export class Debouncer
{
    private timer = 0;
    private debounceTimeInMilliseconds: number;

    constructor(debounceTimeInMilliseconds: number)
    {
        this.debounceTimeInMilliseconds = debounceTimeInMilliseconds;
    }

    public run(callback: () => void)
    {
        window.clearTimeout(this.timer);

        this.timer = window.setTimeout(
            () => callback(),
            this.debounceTimeInMilliseconds,
        );
    }
}

export const debounceTimeInMilliseconds = 300;
export const longDebounceTimeInMilliseconds = 1000;
